import Vue from 'vue'
import Router from 'vue-router'
import Uccn from '@/pages/main/uccn' //引入首页框架
import Contact from '@/pages/main/contact' //引入联系我们页面
import School from '@/pages/main/school' //引入数字营销学院
import Program from '@/pages/main/program' //引入解决方案
//import Customization from '@/pages/main/porject/customization'//引入解决方案中的定制网站
import Google from '@/pages/main/porject/google' //引入解决方案中的google
import About from '@/pages/main/aboutus' //引入关于我们
import Seo from '@/pages/main/porject/seo' //引入解决方案中的seo
import Case from '@/pages/main/case' //引入精彩案例
import Email from '@/pages/main/porject/email' //引入邮件营销
import Solution from '@/pages/main/porject/solution' //引入视频拍摄
import FAQ from '@/pages/main/faq' //引入常见问题
import Artical from '@/pages/main/artical' //引入文章


import Login from '@/pages/adime/login' //登录页面
import Admin from '@/pages/adime/admin' //登录页面


import Social from '@/pages/main/porject/social'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import style
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )
Vue.use(ElementUI);

Vue.use(Router)

export default new Router({
    mode: "history",
    routes: [{
            path: '/',
            name: 'Uccn',
            component: Uccn,
            meta: { title: '温州外贸官网搭建-温州外贸推广-温州领英推广-温州谷歌推广-温州SEO优化-温州外贸独立站建设-温州蓝鲸数字科技有限公司' },
            children: [{
                    path: 'contact',
                    name: 'Contact',
                    component: Contact,
                    meta: { title: '联系我们，加入我们 - 温州蓝鲸数字科技有限公司' },
                },
                {
                    path: 'school',
                    name: 'School',
                    component: School,
                    meta: { title: '温州蓝鲸数字营销学院， 关注微信公众号：蓝鲸数字营销学院 - 温州蓝鲸数字科技有限公司' },
                },
                {
                    path: 'about',
                    name: 'About',
                    component: About,
                    meta: { title: '蓝鲸团队，温州蓝鲸数字科技有限公司的团队介绍，温州蓝鲸数字科技有限公司的介绍' },
                },
                {
                    path: 'case',
                    name: 'Case',
                    component: Case,
                    meta: { title: '温州外贸官网搭建-温州外贸推广-温州外贸优化推广-温州谷歌推广-温州SEO优化-温州外贸独立站建设-温州蓝鲸数字科技有限公司' },
                },
                {
                    path: 'faq',
                    name: 'FAQ',
                    component: FAQ,
                    meta: { title: '温州蓝鲸数字科技有限公司- 客户的常见问题' },
                },
                {
                    path: 'artical/:id',
                    name: 'Artical',
                    component: Artical,
                },
                {
                    path: 'program',
                    name: 'Program',
                    component: Program,
                    // redirect: '/program/customization',
                    meta: { title: '温州高端外贸网站定制服务，温州定制外贸独立站，温州外贸网络推广，温州网站SEO布局， 社交媒体推广， 领英推广 -温州蓝鲸数字科技有限公司' },
                    children: [
                        // {
                        //   path: 'customization',
                        //   name: 'Customization',
                        //   component: Customization,
                        //   meta:{title:'温州谷歌广告推广,谷歌付费广告优化，温州外贸网站推广，温州外贸网站优化，温州网站SEO布局，社交媒体推广，领英推广 -温州蓝鲸数字科技有限公司'},
                        // },
                        {
                            path: 'google',
                            name: 'Google',
                            component: Google,
                            meta: { title: '温州谷歌广告推广,谷歌付费广告优化，温州外贸网站推广，温州外贸网站优化，温州网站SEO布局，社交媒体推广，领英推广 -温州蓝鲸数字科技有限公司' },
                        },
                        {
                            path: 'seo',
                            name: 'Seo',
                            component: Seo,
                            meta: { title: '温州谷歌SEO优化，温州本土SEO团队，温州外贸官网搭建，温州外贸推广，温州谷歌推广 - 温州蓝鲸数字科技有限公司' },
                        },
                        {
                            path: 'email',
                            name: 'Email',
                            component: Email,
                            meta: { title: '温州外贸邮件营销推广，邮件开发潜在客户，温州定制邮件营销，外贸邮件营销上门培训，温州外贸推广 - 温州蓝鲸数字科技有限公司' },
                        },
                        {
                            path: 'social',
                            name: 'Social',
                            component: Social,
                            meta: { title: '温州社交媒体推广，温州领英LinkedIn营销,Facebook营销，温州领英加好友，温州领英开发客户，温州领英公司主页，温州领英推广 -温州蓝鲸数字科技有限公司' },
                        },
                        {
                            path: 'solution',
                            name: 'Solution',
                            component: Solution,
                            meta: { title: '温州视频拍摄，温州企业视频拍摄， 温州企业宣传片拍摄，温州Youtube营销推广， 温州外贸优化，温州外贸推广- 温州蓝鲸数字科技有限公司' },
                        },
                        {
                            path: '*',
                            redirect: '/program'
                        }
                    ]
                }
            ]
        },
        {
            path: '/lanjingshuzilogin',
            name: 'Login',
            component: Login
        },
        {
            path: '/admin',
            name: 'Admin',
            component: Admin
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js